import { WarningStatusIconPipe } from './warning-status-icon.pipe';
import { HasDprSubActivitiesPipe } from './has-dpr-sub-activities.pipe';
import { WarningStatusTooltipPipe } from './warning-status-tooltip.pipe';
import { WarningStatusPipe } from './warning-status.pipe';
import { CopyFromPrevDprTooltipPipe } from './copy-from-prev-dpr-tooltip.pipe';
import { FilterActivityStreamsForDisplayPipe } from './filter-activity-streams-for-display.pipe';
import { ResponsiveLabelPipe } from './responsive-label.pipe';
import { MapNavigationMenuItemPipe } from './map-navigation-menu-item.pipe';

export {
  HasDprSubActivitiesPipe,
  WarningStatusTooltipPipe,
  WarningStatusIconPipe,
  WarningStatusPipe,
  CopyFromPrevDprTooltipPipe,
  FilterActivityStreamsForDisplayPipe,
  ResponsiveLabelPipe,
  MapNavigationMenuItemPipe,
};

export const pipes = [
  HasDprSubActivitiesPipe,
  WarningStatusTooltipPipe,
  WarningStatusIconPipe,
  WarningStatusPipe,
  CopyFromPrevDprTooltipPipe,
  FilterActivityStreamsForDisplayPipe,
  ResponsiveLabelPipe,
  MapNavigationMenuItemPipe,
];
